// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SubjectChoice/Submitted.less
// module id = 1640
// module chunks = 0